<script setup lang="ts">
import { useCommonStore } from '@shared/model'
import { PageType } from '@shared/config'
import { amplitudeConfig as amplitudeConf, trackEvent } from '@shared/lib/amplitude'
import { BtnPrimary, BtnSecondary } from '@shared/ui/button'

defineOptions({
  name: 'BtnBecomeTutor',
})

const props = withDefaults(defineProps<BtnWaitingProps>(), {
  text: 'Become a tutor',
  size: 'medium',
  from: 'Math_page',
})

interface BtnWaitingProps {
  text?: string
  size?: 'big' | 'medium' | 'small'
  from?: string
}

const commonStore = useCommonStore()

const isAggregatorHeader = computed(
  () => props.from === 'header' && commonStore.pageType === PageType.Aggregator,
)

const handleClick = (): void => {
  trackEvent(amplitudeConf.events.clickButton, {
    button_name: 'become_a_tutor',
    button_text: props.text,
    page_type: commonStore.getPageType,
    from: props.from,
  })

  if (commonStore.pageType === PageType.Aggregator) {
    document.getElementById('find-your-role')?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    })
    return
  }

  commonStore.setModalTutorApplication(true)
}
</script>

<template>
  <BtnSecondary
    v-if="isAggregatorHeader"
    :text="text"
    :size="size"
    @click="handleClick"
  />
  <BtnPrimary
    v-else
    :text="text"
    :size="size"
    @click="handleClick"
  />
</template>
